import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Button, Stack,Box, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from 'react-router-dom';
import {PAN_AADHAAR_VERIFICATION_STATUS} from '../../constants';
import Loader from "../reusable Component/Loader";



const EkycStatusCard = ({ aadhaarVerified, panVerified: panFromApi,setIsModalOpen }) => {
  const brandGreen = "#4CAF50";
  const isDesktop = useMediaQuery("(min-width:900px)");
  const navigate = useNavigate();
  const [panVerified, setPanVerified] = useState(panFromApi);

  const glassStyle = {
    backdropFilter: "blur(12px)",
    background: "rgba(255, 255, 255, 0.08)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "20px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
    minHeight: isDesktop ? "140px" : "120px",
  };

  const textStyle = {
    fontFamily: `'SF Pro Display', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
  };

  const handleAadhaarVerify = () => {
    alert("Aadhaar verification started!");
    navigate('/customer/e-kyc');
};

const handlePanVerify = () => {
    alert("PAN verification is under developement");
  };

  const handleAadhaarDetails = ()=>{
    setIsModalOpen(true);
  }

  return (
    <Stack
      spacing={3}
      sx={{
        maxWidth: isDesktop ? "800px" : "100%",
        mx: "auto",
        mt: isDesktop ? 6 : 3,
        p: isDesktop ? 4 : 2,
      }}
    >
      {/* Aadhaar Card */}
      <Card sx={glassStyle}>
        <CardContent sx={{ p: isDesktop ? 4 : 2 }}>
          <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography
                variant={isDesktop ? "h5" : "body1"}
                fontWeight={600}
                sx={{ ...textStyle, letterSpacing: 0.2 }}
              >
                Aadhaar Verification
              </Typography>
            </Box>
            <Box mt={1} display="flex" alignItems="center" gap={1}>
              {aadhaarVerified ? (
                <>
                  <CheckCircleIcon sx={{ color: brandGreen, fontSize: isDesktop ? 24 : 18 }} />
                  <Typography sx={{ color: brandGreen, fontSize: isDesktop ? 16 : 14, ...textStyle }}>
                    Verified
                  </Typography>
                </>
              ) : (
                <Typography sx={{ color: "#ff4d4d", fontSize: isDesktop ? 16 : 14, ...textStyle }}>
                  Not Verified
                </Typography>
              )}
            </Box>

            <Box mt={2} display="flex" justifyContent="flex-end">
           {/* <Button
                variant="contained"
                sx={{
                //   "&:hover": { bgcolor: "#1565c0" },
                  textTransform: "none",
                  fontSize: isDesktop ? 16 : 14,
                  py: 1,
                  px: 2,
                  mr:2,
                  borderRadius: "14px",
                  ...textStyle,
                }}
                // disabled={aadhaarVerification}
                onClick={handleAadhaarDetails}
              >
                open details
              </Button> */}
              <Button
                variant="contained"
                sx={{
                  "&:hover": { bgcolor: aadhaarVerified ? "" : "#1565c0" },
                  textTransform: "none",
                  fontSize: isDesktop ? 16 : 14,
                  py: 1,
                  px: 2,
                  borderRadius: "14px",
                  ...textStyle,
                }}
                disabled={aadhaarVerified}
                onClick={handleAadhaarVerify}
              >
                {aadhaarVerified ? "Verified" : "Start Verification"}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* PAN Card */}
      {/* <Card sx={glassStyle}>
        <CardContent sx={{ p: isDesktop ? 4 : 2 }}>
          <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography
                variant={isDesktop ? "h5" : "body1"}
                fontWeight={600}
                sx={{ ...textStyle, letterSpacing: 0.2 }}
              >
                PAN Verification
              </Typography>
            </Box>

            <Box mt={1} display="flex" alignItems="center" gap={1}>
              {panVerified ? (
                <>
                  <CheckCircleIcon sx={{ color: brandGreen, fontSize: isDesktop ? 24 : 18 }} />
                  <Typography sx={{ color: brandGreen, fontSize: isDesktop ? 16 : 14, ...textStyle }}>
                    Verified
                  </Typography>
                </>
              ) : (
                <Typography sx={{ color: "#ff4d4d", fontSize: isDesktop ? 16 : 14, ...textStyle }}>
                  Not Verified
                </Typography>
              )}
            </Box>

            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                sx={{
                  // bgcolor: panVerified ? "#444" : "#1976d2",
                  // "&:hover": { bgcolor: panVerified ? brandGreen  : "#1565c0" },
                  textTransform: "none",
                  fontSize: isDesktop ? 16 : 14,
                  py: 1,
                  px: 2,
                  borderRadius: "14px",
                  ...textStyle,
                }}
                disabled={panVerified || !aadhaarVerified} // Aadhaar must be verified first
                onClick={handlePanVerify}
              >
                {panVerified ? "Verified" : "Start Verification"}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card> */}
    </Stack>
  );
};
   const CustomerDashboardComponent = () => {

          const [loading, setLoading] = useState(false);
          const [formData,setFormData] = useState([]);
         const [isModalOpen, setIsModalOpen] = useState(false);



    const [aadhaarState,setAadhaarState] = useState(null);

     const getPanAadhaarVerificationStatus = async ()=> {
    try {
       const leadId = JSON.parse(localStorage.getItem("eKYCData")); 

      if (!leadId.lead_id) {
        // console.error("Lead ID not found in localStorage");
        return;
      }

    //  let leadId=45893;

    // setLoading(true);
      const apiUrl = `${PAN_AADHAAR_VERIFICATION_STATUS}/${leadId.lead_id}`; 

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();
    

      if (response.ok) {
       
        setAadhaarState(data.data.checkVerification.aadhaarVerification)
        setFormData(data.data.aadhaarDetails)
        // you can now set state to disable/enable button
                  // setLoading(false);
      } else {
        console.error("Error from API:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  }

  useEffect(() => {
    getPanAadhaarVerificationStatus();
    console.log("running.......")
        //   const leadId = JSON.parse(localStorage.getItem("eKYCData")); 
        //   console.log("leadId:::::::",leadId.lead_id)
  }, []); 


    return(
        <>
        {loading && <Loader open={loading} />}
          <EkycStatusCard
          formData={formData}
          setIsModalOpen={setIsModalOpen}
          aadhaarVerified={aadhaarState}
          // panVerified={backendData.panVerified}
          onStartPanVerification={() => console.log("Start PAN Verification")}
        />
   
        </>
    );
}

export default CustomerDashboardComponent;